import { opsHi } from '@/features/catalog/ops/messages';
import { datHi } from '@/features/catalog/data/messages';
import { catHi } from '@/features/catalog/messages';
import { serHi } from '@/features/serials/messages';
import { colHi } from '@/features/collections/messages';
import type { Messages } from './en';
import { svcHi } from '@/features/services/messages';
import { opacHi } from '@/features/opac/messages';
import { opacMoreHi } from '@/features/opac/messagesMore';

/** Hindi catalogue. Typed against the English keys: a missing key is a compile error. */
export const hi: Messages = {
  'common.save': 'सहेजें',
  'common.saveChanges': 'बदलाव सहेजें',
  'common.cancel': 'रद्द करें',
  'common.delete': 'हटाएँ',
  'common.edit': 'संपादित करें',
  'common.close': 'बंद करें',
  'common.back': 'वापस',
  'common.next': 'अगला',
  'common.previous': 'पिछला',
  'common.search': 'खोजें',
  'common.loading': 'लोड हो रहा है',
  'common.retry': 'फिर कोशिश करें',
  'common.confirm': 'पुष्टि करें',
  'common.yes': 'हाँ',
  'common.no': 'नहीं',
  'common.actions': 'कार्रवाइयाँ',
  'common.filter': 'फ़िल्टर',
  'common.filters': 'फ़िल्टर',
  'common.clear': 'साफ़ करें',
  'common.apply': 'लागू करें',
  'common.export': 'निर्यात',
  'common.import': 'आयात',
  'common.print': 'प्रिंट',
  'common.download': 'डाउनलोड',
  'common.upload': 'अपलोड',
  'common.add': 'जोड़ें',
  'common.remove': 'हटाएँ',
  'common.more': 'और',
  'common.view': 'देखें',
  'common.details': 'विवरण',
  'common.status': 'स्थिति',
  'common.name': 'नाम',
  'common.date': 'तारीख़',
  'common.all': 'सभी',
  'common.none': 'कोई नहीं',
  'common.select': 'चुनें',
  'common.optional': 'वैकल्पिक',
  'common.required': 'आवश्यक',
  'common.copy': 'कॉपी करें',
  'common.copied': 'कॉपी हो गया',
  'common.noResults': 'कोई परिणाम नहीं मिला',
  'common.today': 'आज',
  'common.yesterday': 'कल',
  'common.rowsSelected': '{count} चुने गए',
  'common.page': 'पृष्ठ {page} / {total}',
  'common.showing': '{total} में से {from} से {to} दिख रहे हैं',
  'common.rowsPerPage': 'प्रति पृष्ठ पंक्तियाँ',
  'common.submit': 'जमा करें',
  'common.continue': 'जारी रखें',
  'common.finish': 'पूरा करें',
  'common.create': 'बनाएँ',
  'common.new': 'नया',
  'common.refresh': 'ताज़ा करें',
  'common.sortBy': '{column} के अनुसार क्रमबद्ध करें',
  'common.breadcrumb': 'नेविगेशन पाथ',
  'nav.home': 'मुखपृष्ठ',
  'nav.search': 'खोज',
  'nav.browse': 'ब्राउज़ करें',
  'nav.lists': 'सूचियाँ',
  'nav.events': 'कार्यक्रम',
  'nav.rooms': 'अध्ययन कक्ष',
  'nav.courses': 'पाठ्यक्रम आरक्षित पुस्तकें',
  'nav.resources': 'ई-संसाधन',
  'nav.account': 'मेरा खाता',
  'nav.signIn': 'साइन इन',
  'nav.signOut': 'साइन आउट',
  'nav.register': 'पुस्तकालय से जुड़ें',
  'nav.dashboard': 'डैशबोर्ड',
  'nav.circulation': 'परिसंचरण',
  'nav.catalog': 'सूचीपत्र',
  'nav.patrons': 'सदस्य',
  'nav.fines': 'जुर्माना और शुल्क',
  'nav.acquisitions': 'अधिप्राप्ति',
  'nav.reports': 'रिपोर्ट',
  'nav.tools': 'उपकरण',
  'nav.admin': 'प्रशासन',
  'nav.staffConsole': 'स्टाफ़ कंसोल',
  'nav.publicCatalogue': 'सार्वजनिक सूचीपत्र',
  'nav.more': 'और',
  'nav.main': 'मुख्य नेविगेशन',
  'shell.skipToContent': 'मुख्य सामग्री पर जाएँ',
  'shell.openMenu': 'मेनू खोलें',
  'shell.collapseSidebar': 'साइडबार छोटा करें',
  'shell.expandSidebar': 'साइडबार फैलाएँ',
  'shell.searchEverything': 'सदस्य, पुस्तकें और कार्रवाइयाँ खोजें',
  'shell.commandPalette': 'कमांड पैलेट',
  'shell.notifications': 'सूचनाएँ',
  'shell.noNotifications': 'सब कुछ देख लिया गया है',
  'shell.library': 'पुस्तकालय',
  'shell.switchLibrary': 'पुस्तकालय बदलें',
  'shell.shortcuts': 'कीबोर्ड शॉर्टकट',
  'shell.profile': 'प्रोफ़ाइल',
  'shell.language': 'भाषा',
  'shell.theme': 'थीम',
  'shell.offline': 'आप ऑफ़लाइन हैं। दोबारा जुड़ने तक बदलाव सहेजे नहीं जाएँगे।',
  'theme.light': 'हल्का',
  'theme.dark': 'गहरा',
  'theme.system': 'सिस्टम',
  'auth.signInTitle': 'वापसी पर स्वागत है',
  'auth.staffSignInTitle': 'स्टाफ़ साइन इन',
  'auth.login': 'कार्ड नंबर, यूज़र आईडी या ईमेल',
  'auth.password': 'पासवर्ड',
  'auth.signingIn': 'साइन इन हो रहा है',
  'auth.forgot': 'पासवर्ड भूल गए?',
  'auth.resetTitle': 'अपना पासवर्ड रीसेट करें',
  'auth.resetSend': 'रीसेट लिंक भेजें',
  'auth.resetSent': 'यदि यह खाता मौजूद है, तो रीसेट लिंक भेजा जा रहा है।',
  'auth.newPassword': 'नया पासवर्ड',
  'auth.confirmPassword': 'नए पासवर्ड की पुष्टि करें',
  'auth.passwordsMatch': 'पासवर्ड एक जैसे होने चाहिए',
  'auth.invalidCredentials': 'कार्ड नंबर या पासवर्ड गलत है।',
  'auth.sessionExpired': 'आपका सत्र समाप्त हो गया है। कृपया फिर से साइन इन करें।',
  'auth.noAccount': 'पुस्तकालय में नए हैं?',
  'auth.staffNotice': 'यह क्षेत्र पुस्तकालय स्टाफ़ के लिए है।',
  'opac.searchPlaceholder': 'शीर्षक, लेखक, विषय या आईएसबीएन खोजें',
  'opac.heroTitle': 'अपनी अगली पसंदीदा किताब खोजें',
  'opac.heroSubtitle': 'पूरा संग्रह खोजें, एक टैप में आरक्षित करें और कहीं से भी अपने ऋण संभालें।',
  'opac.available': 'उपलब्ध',
  'opac.unavailable': 'सभी प्रतियाँ ऋण पर हैं',
  'opac.placeHold': 'आरक्षण करें',
  'opac.copies': '{count} प्रतियाँ',
  'opac.byAuthor': '{author} द्वारा',
  'opac.results': '{count} परिणाम',
  'opac.newArrivals': 'नई आवक',
  'opac.popularNow': 'अभी लोकप्रिय',
  'opac.dueOn': 'वापसी तिथि {date}',
  'opac.renew': 'नवीनीकरण',
  'opac.renewAll': 'सभी का नवीनीकरण',
  'opac.overdue': 'अतिदेय',
  'opac.avail.available': '{total} प्रतियों में से {available} उपलब्ध',
  'opac.avail.allOnLoan': 'सभी {total} प्रतियाँ उधार पर',
  'opac.avail.notForLoan': 'उधार हेतु नहीं',
  'opac.avail.noCopies': 'कोई प्रति उपलब्ध नहीं',
  'opac.item.available': 'उपलब्ध',
  'opac.item.onLoan': 'उधार पर',
  'opac.item.onHoldShelf': 'होल्ड शेल्फ़ पर',
  'opac.item.inTransit': 'पारगमन में',
  'opac.item.damaged': 'क्षतिग्रस्त',
  'opac.item.notForLoan': 'उधार हेतु नहीं',
  'card.status.active': 'सक्रिय',
  'card.status.expired': 'समाप्त',
  'card.status.lost': 'खोया हुआ',
  'card.status.restricted': 'सीमित',
  'account.loans': 'ऋण',
  'account.holds': 'आरक्षण',
  'account.fines': 'जुर्माना',
  'account.history': 'पठन इतिहास',
  'account.lists': 'मेरी सूचियाँ',
  'account.suggestions': 'सुझाव',
  'account.ill': 'अंतर-पुस्तकालय ऋण',
  'account.events': 'मेरे कार्यक्रम',
  'account.profile': 'प्रोफ़ाइल',
  'account.notifications': 'सूचनाएँ',
  'account.preferences': 'प्राथमिकताएँ',
  'account.digitalCard': 'डिजिटल पुस्तकालय कार्ड',
  'kiosk.title': 'स्वयं चेकआउट',
  'kiosk.scanCard': 'अपना पुस्तकालय कार्ड स्कैन करें',
  'kiosk.scanBook': 'जो किताबें लेनी हैं उन्हें स्कैन करें',
  'kiosk.done': 'हो गया',
  'kiosk.disabled': 'स्वयं चेकआउट कियोस्क वर्तमान में अक्षम है',
  'kiosk.twoFactor': 'दो-चरणीय प्रमाणीकरण आवश्यक है',
  'footer.hours': 'खुलने का समय',
  'footer.contact': 'संपर्क',
  'footer.about': 'पुस्तकालय के बारे में',
  'footer.rights': 'सर्वाधिकार सुरक्षित।',
  'error.generic': 'कुछ गलत हो गया। कृपया फिर कोशिश करें।',
  'error.notFoundTitle': 'वह पृष्ठ नहीं मिला',
  'error.notFoundBody': 'हो सकता है पृष्ठ हट गया हो, या लिंक गलत लिखा गया हो।',
  'error.forbiddenTitle': 'आपके पास इसकी अनुमति नहीं है',
  'error.forbiddenBody': 'आवश्यक अनुमति के लिए पुस्तकालय प्रशासक से कहें।',
  'error.network': 'सर्वर से संपर्क नहीं हो पा रहा। अपना कनेक्शन जाँचें।',
  'error.goHome': 'मुखपृष्ठ पर जाएँ',
  'error.fieldRequired': 'यह फ़ील्ड आवश्यक है',
  'status.active': 'सक्रिय',
  'status.inactive': 'निष्क्रिय',
  'status.pending': 'लंबित',
  'status.overdue': 'अतिदेय',
  'status.ready': 'लेने के लिए तैयार',
  'status.lost': 'खोई हुई',
  'status.onShelf': 'शेल्फ़ पर',
  'status.checkedOut': 'जारी की गई',
  'placeholder.title': 'यह स्क्रीन बनाई जा रही है',
  'placeholder.body': 'इस क्षेत्र का नेविगेशन और अनुमतियाँ तय हैं। स्क्रीन जल्द आएगी।',
  // admin and tools page headers
  'admin.libraries.title': 'पुस्तकालय',
  'admin.libraries.description': 'शाखाएँ, समय, अवकाश और पुस्तकालय समूह।',
  'admin.itemTypes.title': 'सामग्री प्रकार',
  'admin.itemTypes.description': 'ऋण श्रेणियाँ और उनके डिफ़ॉल्ट।',
  'admin.locations.title': 'शेल्फ़ स्थान',
  'admin.locations.description': 'शाखा के भीतर सामग्री कहाँ रखी जाती है।',
  'admin.collections.title': 'संग्रह कोड',
  'admin.collections.description': 'आँकड़ों और नियमों के लिए संग्रह समूह।',
  'admin.rules.title': 'परिसंचरण नियम',
  'admin.rules.description': 'सदस्य श्रेणी और सामग्री प्रकार के अनुसार ऋण अवधि, नवीनीकरण और जुर्माने।',
  'admin.preferences.title': 'सिस्टम प्राथमिकताएँ',
  'admin.preferences.description': 'सिस्टम का हर कॉन्फ़िगर करने योग्य व्यवहार।',
  'admin.av.title': 'अधिकृत मान',
  'admin.av.description': 'फ़ॉर्म में प्रयुक्त नियंत्रित शब्दावलियाँ।',
  'admin.staff.title': 'भूमिकाएँ और अनुमतियाँ',
  'admin.staff.description': 'कौन क्या कर सकता है।',
  'admin.apiClients.title': 'API क्लाइंट',
  'admin.apiClients.description': 'एकीकरण के लिए क्रेडेंशियल।',
  'admin.webhooks.title': 'वेबहुक',
  'admin.webhooks.description': 'घटनाएँ होने पर अन्य सिस्टम को सूचित करें।',
  'admin.audit.title': 'ऑडिट लॉग',
  'admin.audit.description': 'कर्मचारियों द्वारा किए गए हर बदलाव का रिकॉर्ड।',
  'admin.system.title': 'सिस्टम स्वास्थ्य',
  'admin.system.description': 'संस्करण, जॉब, भंडारण और कनेक्टिविटी।',
  'tools.notices.title': 'सूचना टेम्पलेट',
  'tools.notices.description': 'सदस्यों को मिलने वाले संदेश संपादित करें।',
  'tools.queue.title': 'संदेश कतार',
  'tools.queue.description': 'भेजे जाने वाले संदेश और उनकी स्थिति।',
  'tools.calendar.title': 'अवकाश कैलेंडर',
  'tools.calendar.description': 'वे दिन जब हर शाखा बंद रहती है।',
  'tools.news.title': 'समाचार',
  'tools.news.description': 'कैटलॉग और स्टाफ कंसोल की घोषणाएँ।',
  'tools.cron.title': 'निर्धारित कार्य',
  'tools.cron.description': 'आवर्ती पृष्ठभूमि कार्य।',
  'tools.uploads.title': 'अपलोड',
  'tools.uploads.description': 'फ़ाइलें और चित्र।',
  ...svcHi,
  ...catHi,
  ...serHi,
  ...colHi,
  ...opsHi,
  ...datHi,
  ...opacHi,
  ...opacMoreHi,
};
